import { useQuery } from '@tanstack/react-query';

import type { GetMeetingsParams } from './meetingService';

import { MeetingKey } from './keys';
import { MeetingService } from './meetingService';

export function useGetAssignedMeetings(params: GetMeetingsParams, enabled = true) {
  return useQuery({
    queryKey: [MeetingKey.MEETINGS, params],
    placeholderData: [],
    queryFn: () => MeetingService.getAssignedMeetings(params).then((response) => response.data),
    enabled,
  });
}
